module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('span', {
    staticClass: "filter-map-active",
    attrs: {
      "id": "filtermapactive"
    }
  }, [_c('label', {
    staticClass: "switch"
  }, [_c('input', {
    attrs: {
      "name": "filtermapactive",
      "type": "checkbox"
    },
    domProps: {
      "checked": _vm.get
    },
    on: {
      "change": _vm.set
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "slider round"
  })])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-67edaf98"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/FilterMapActive.vue
// module id = 439
// module chunks = 1